export type PrefixType = 'rmx' | 'nexus' | 'lenovo' | '8848' | 'zte'
    | 'hlte' | 'nokia' | 'gionee' | 'lm-' | 'kuliao' | 'nubia' | 'pixel';

export const phoneAgentPrefix = {
    'rmx': 'realme',
    'nexus': 'nexus',
    'lenovo': 'lenovo',
    '8848': '8848',
    'zte': 'zte',
    'hlte': 'haixin',
    'nokia': 'nokia',
    'gionee': 'jinli',
    'lm-': 'lg',
    'kuliao': 'kuliao',
    'nubia': 'nubia',
    'pixel': 'google pixel',
    's08a': 'suoai',
    'le': 'leshi',
    '20170829d': 'xiaolajiao',
    'ticktock': 'ticktock',
    'n2301': 'n2301',
    'asus_': 'huashuo',
    'tyh212u': 'dianxintianyi',
    'tdt-ma01': 'xiapu'
};

export type BrowserType = 'micromessenger' | 'samsungbrowser' | 'vivobrowser'
    | 'miuibrowser' | 'mqqbrowser' | 'quark'
    | 'heytapbrowser' | 'channelname/feishu' | 'csdnapp';

export const BrowserAgent = {
    'micromessenger': 'weixin',
    'samsungbrowser': 'sanxingbrowser',
    'vivobrowser': 'vivobrowser',
    'miuibrowser': 'xiaomibrowser',
    'mqqbrowser': 'qqbrowser',
    'quark': 'quark',
    'heytapbrowser': 'oppobrowser',
    'channelname/feishu': 'feishu',
    'csdnapp': 'csdn',
}